import { render, staticRenderFns } from "./indexClientEdit.vue?vue&type=template&id=ab188f02&scoped=true"
import script from "./indexClientEdit.vue?vue&type=script&lang=js"
export * from "./indexClientEdit.vue?vue&type=script&lang=js"
import style0 from "./indexClientEdit.vue?vue&type=style&index=0&id=ab188f02&prod&lang=scss"
import style1 from "./indexClientEdit.vue?vue&type=style&index=1&id=ab188f02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab188f02",
  null
  
)

export default component.exports